import React from "react";
import "./PaymentHandle.css";

const PaymentHandle = ({ isOpen = true }) => {
  if (!isOpen) return null;

  return (
    <div className="payment-overlay">
      <div className="payment-modal">
        <div className="payment-spinner" aria-hidden="true"></div>
        <p>Vous serez redirigé vers le paiement en quelques instants</p>
      </div>
    </div>
  );
};

export default PaymentHandle;